import axios from 'axios';
import React, { Component } from "react";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { FaTrash, FaRegClock } from 'react-icons/fa';
import Grid from '@material-ui/core/Grid';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { SheetJSFT } from '../screens/types.js';
import jscolor from '../jscolor';
import XLSX from 'xlsx';
import { make_cols } from '../screens/MakeColumns';
import { getTeamById, UpdateTeam, getAssetsInfo } from "../services/userServices";
import '../App.css'

import {
  Input,
  createMuiTheme,
  MuiThemeProvider,
  Button
} from "@material-ui/core";
import { withStyles, } from "@material-ui/core";
import { PropTypes } from "prop-types";
import TopBar from "../components/TopBar";
import Loader from 'react-loader-spinner';
import moment from 'moment'



const theme = createMuiTheme({
  overrides: {
    MuiChip: {
      root: {
        fontSize: "11px",
        color: "#3c4043",
        marginTop: 20,
        height: 25,
        backgroundColor: "rgba(0, 0, 0, 0.10)",
        padding: "3px 5px"
      },
      deleteIcon: {
        width: 14,
        height: 14,
        margin: 0
      },
      label: {
        color: "#3c4043",
        cursor: "pointer",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "11px",
        margin: "0 6px",
        padding: "1px",
        paddingLeft: 0,
        paddingRight: 0,
        marginRight: 0,
        fontWeight: 600
      }
    }
  },
  typography: {
    useNextVariants: true
  }
});


class EditTeamPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
      getMydata: props.location.state,
      openNote: false,


      eventName: '',
      stadiumLoc: '',
      time_zone: {},
      eventDate: new Date(),
      eventTime: moment(new Date(), [moment.ISO_8601, 'HH:mm']),
      endTime: moment(new Date(new Date().setMinutes(new Date().getMinutes() + 1)), [moment.ISO_8601, 'HH:mm']),
      newData: {},
      eventendDate: new Date(),
      team1LogoURL: '',
      team2LogoURL: '',

      date: "",
      currentDate: "",


      team1Name: '',
      team1Logo: '',
      team1Hex1: 'FFFFFF',
      team1Hex2: 'FFFFFF',

      eventPhotoURL: '',
      eventStadiumURL: '',
      team2Name: '',
      team2Logo: '',
      team2Hex1: 'FFFFFF',
      team2Hex2: 'FFFFFF',
      eventPhotoname: '',
      eventstadiumname: '',
      dataResponse: {},
      fileName: '',
      slideCards: false,
      cardStyles: false,
      cols: [],
      loading: false,
      image1Checked: true,
      image2Checked: true,
      image3Checked: true,
      fileChecked: true,
      image1Message: '',
      image2Message: '',
      fileMessage: '',
      image3Message: '',
      checkDisabled: false

    }

    this.onCreated = this.onCreated.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleToggle = this.handleToggle.bind(this)

  }


  /************************************************************************************************************************************* */

  // onCreated() {
  //   const cpElem = this.colorPicker.element.nextElementSibling;
  //   cpElem.insertBefore(this.colorPicker.element, cpElem.children[1]);
  // }

  onCreated() {
    let cpElem = this.colorPicker.element.nextElementSibling;
    cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]);
    // console.log('====================================', cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]))
    // console.log("VALUE IS ", cpElem)
    // console.log('====================================')
  }

  /************************************************************************************************************************************ */

  handleeventName = evt => {
    try {
      this.setState({ eventName: evt.target.value });
    } catch (err) {
      console.log("error at handling EventName in dataGeneration");
    }
  };

  handlestadiumLoc = evt => {
    try {
      this.setState({ stadiumLoc: evt.target.value });
    } catch (err) {
      console.log("error at handling StadiumLoc in dataGeneration");
    }
  };

  // removeEvent = () => {
  //   this.state.checkDisabled = true
  //   this.setState({
  //     eventPhotoURL: '',
  //     eventPhotoname: ''
  //   })
  //   document.getElementById("EditeventPhoto").value = "";
  // }
  removeAsset = () => {
    this.state.checkDisabled = false
    this.setState({
      team1LogoName: '',
      team1LogoURL: ''
    })
    document.getElementById("EditTeam1Logo").value = "";
  }
  removeStadium = () => {
    this.state.checkDisabled = false
    this.setState({
      stadiumImageURL: '',
      eventstadiumname: ''
    })
    document.getElementById("Lighshow").value = ""
  }
  removeFiles = () => {
    this.state.checkDisabled = false
    this.state.team1Hex1 = 'FFFF'
    this.state.team1Hex2 = 'FFFF'
    this.setState({
      fileName: ''
    })
    document.getElementById("EditFiles").value = ""
    document.querySelector('input[id=teamOneHex1').value  = " "
    document.querySelector('input[id=teamOneHex2').value  = " "
  }
  checkFile(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0] !== undefined && e.target.files[0].type == "application/vnd.oasis.opendocument.spreadsheet") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        // this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      // console.log(this.state.fileChecked)
    }
  }
  handleFile = () => {
    /* Boilerplate to set up FileReader */
    let reader = new FileReader();
    let rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      let bstr = e.target.result;
      let wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
      /* Get first worksheet */
      let wsname = wb.SheetNames[0];
      let ws = wb.Sheets[wsname];
      if(Object.entries(ws).length==0){
        this.state.fileChecked = false
        this.state.fileMessage = 'Empty file cannot be accepted'
        this.checkDisabled()
      }
      else{
        this.state.fileChecked = true
       
          let Fdata = XLSX.utils.sheet_to_json(ws);
          let myCommaField = [];
          let mycolor =[];
          Fdata.forEach(element => {
            myCommaField.push(Object.entries(element).flat())
            for(var i=0; i< myCommaField[0].length; i++){
              if(myCommaField[0][i].includes(",")){
                mycolor.push(myCommaField[0][i]);
              }
            }
            myCommaField = [];
          })
          var filteredArray = mycolor.filter(function(item, pos){
            return mycolor.indexOf(item)== pos; 
          });
          this.setState({
            team1Hex1 : filteredArray[0].split(",")[0],
            team1Hex2 : filteredArray[0].split(",")[1]
          })
          document.querySelector('input[id=teamOneHex1').value = filteredArray[0].split(",")[0];
          document.querySelector('input[id=teamOneHex2').value = filteredArray[0].split(",")[1];
          this.setState({ fileJSON: Fdata, cols: make_cols(ws['!ref']) }, () => {
          let seatsSectionKeys = [];
          Object.keys(this.state.fileJSON[0]).forEach(function (element) {
            if (element !== 'time' && element.startsWith("_") !== true && element.length > 25 !== true) {
              seatsSectionKeys.push(element);
            }
          });
          this.setState({
            SelectOptions: seatsSectionKeys.sort()
          })
        });
        this.state.checkDisabled=false;
      }
    };

    if (rABS) {
      reader.readAsBinaryString(document.querySelector('input[id=EditFiles]').files[0]);
    } else {
      reader.readAsArrayBuffer(document.querySelector('input[id=EditFiles]').files[0]);
    };
  }


  // removeMe = (type) => {
  //   if (type === 0) {
  //     this.setState({
  //       team1LogoName: ''
  //     })
  //     document.querySelector('img[id=EditTeam1Logo]').src = ""
  //   }
  //   if (type === 1) {
  //     this.setState({
  //       team2LogoName: ''
  //     })
  //     document.querySelector('img[id=EditTeam2Logo]').src = ""
  //   }

  // }
  getName = evt => {
    // if (document.querySelector('input[id=EditeventPhoto]') !== null && document.querySelector('input[id=EditeventPhoto]').files[0] !== undefined) {
    //   this.state.checkDisabled = true
    //   this.setState({
    //     eventPhotoname: document.querySelector('input[id=EditeventPhoto]').files[0].name
    //   })

    //   if (document.querySelector('input[id=EditeventPhoto]').files[0].type == "image/jpeg" ||
    //     document.querySelector('input[id=EditeventPhoto]').files[0].type == "image/png" ||
    //     document.querySelector('input[id=EditeventPhoto]').files[0].type == "image/svg+xml") {
    //     if (document.querySelector('input[id=EditeventPhoto]').files[0].size >= 5000000) {
    //       this.state.image1Checked = false
    //       this.state.image1Message = 'Image should be less than 5 MB in size'
    //     } else {
    //       this.state.image1Checked = true
    //       this.checkDisabled()
    //     }
    //   }
    //   else {
    //     this.state.image1Checked = false
    //     this.state.image1Message = 'Only Images are accepted'
    //     this.checkDisabled()
    //   }
    // }
    if (document.querySelector('input[id=Lighshow]') !== null && document.querySelector('input[id=Lighshow]').files[0] !== undefined) {
      this.state.checkDisabled = true
      this.setState({
        eventstadiumname: document.querySelector('input[id=Lighshow]').files[0].name,
        stadiumImageURL:''
      })
      if (document.querySelector('input[id=Lighshow]').files[0].type == "image/jpeg" ||
        document.querySelector('input[id=Lighshow]').files[0].type == "image/png" ||
        document.querySelector('input[id=Lighshow]').files[0].type == "image/svg+xml") {
        if (document.querySelector('input[id=Lighshow]').files[0].size >= 5000000) {
          this.state.image2Checked = false
          this.state.image2Message = 'Image should be less than 5 MB in size'
        } else {
          this.state.image2Checked = true
          this.checkDisabled()
        }
      }
      else {
        this.state.image2Checked = false
        this.state.image2Message = 'Only Images are accepted'
        this.checkDisabled()
      }


    }
    if (document.querySelector('input[id=EditFiles]') !== null && document.querySelector('input[id=EditFiles]').files[0] !== undefined) {
     
      this.setState({
        fileName: document.querySelector('input[id=EditFiles]').files[0].name
      })
    }
    if (document.querySelector('input[id=EditTeam1Logo]') !== null && document.querySelector('input[id=EditTeam1Logo]').files[0] !== undefined) {
       this.state.checkDisabled = true
       this.setState({
        team1LogoName: document.querySelector('input[id=EditTeam1Logo]').files[0].name,
        team1LogoURL: ''
      })

      if (document.querySelector('input[id=EditTeam1Logo]').files[0].type == "image/jpeg" ||
        document.querySelector('input[id=EditTeam1Logo]').files[0].type == "image/png" ||
        document.querySelector('input[id=EditTeam1Logo]').files[0].type == "image/svg+xml") {
        if (document.querySelector('input[id=EditTeam1Logo]').files[0].size >= 5000000) {
          this.state.image3Checked = false
          this.state.image3Message = 'Image should be less than 5 MB in size'
        } else {
          this.state.image3Checked = true
          this.checkDisabled()
        }
      }
      else {
        this.state.image3Checked = false
        this.state.image3Message = 'Only Images are accepted'
        this.checkDisabled()
        // console.log(this.state.fileChecked)
      }
    }
    if (document.querySelector('input[id=EditTeam2Logo]') !== null && document.querySelector('input[id=EditTeam2Logo]').files[0] !== undefined) {
      this.setState({
        team2LogoName: document.querySelector('input[id=EditTeam2Logo]').files[0].name
      })
    }
  }

  checkDisabled() {
    this.state.checkDisabled = true
    if ( this.state.image2Checked && this.state.image3Checked && this.state.fileChecked) {
      this.state.checkDisabled = false
    }
  }
  handleeventDate = evt => {
    try {
      let today = new Date()
      this.setState({
        eventDate: evt,
        eventTime: moment(today, [moment.ISO_8601, 'HH:mm']),
        endTime: moment(new Date(today.setMinutes(today.getMinutes() + 1)), [moment.ISO_8601, 'HH:mm']),
        eventendDate: evt,
      })
    } catch (err) {
      console.log("error at handling EventDate in dataGeneration");

    }
  }
  handleeventendeDate = evt => {
    try {
      let today = new Date()
      this.setState({
        eventendDate: evt,
        //eventTime: moment(today, [moment.ISO_8601, 'HH:mm']),
        endTime: moment(new Date(today.setMinutes(today.getMinutes() + 1)), [moment.ISO_8601, 'HH:mm'])
      })
    } catch (err) {
      console.log("error at handling EventDate in dataGeneration");

    }
  }
  handleeventTime = evt => {
    try {
      this.setState({
        eventTime: moment(evt, [moment.ISO_8601, 'HH:mm']),
      }, () => {
        this.handleEndTime(new Date(evt.setMinutes(evt.getMinutes() + 1)));
      })
    } catch (err) {
      console.log("error at handling EventTime in dataGenearation");

    }
  }

  handleEndTime = evt => {
    try {
      const minTime = moment(this.state.eventTime.toDate(), [moment.ISO_8601, 'HH:mm'])
      const maxTime = moment("24:00", "HH:mm");
      if (minTime.isBefore(evt) && maxTime.isAfter(evt)) {
        //Here is corect time
        this.setState({
          endTime: moment(evt, [moment.ISO_8601, 'HH:mm'])
        })
      } else {
        alert("Select a valid time")
      }
    } catch (err) {
      console.log("error at handling EndTime in dataGenearation", err);
    }
  }


  /******************************************************************** */


  onTimezoneChange = (event) => {
    var tz = event.target.value
    this.setState({
      eventTime: moment(new Date((this.state.eventTime).toDate()).toLocaleString('en-US', { timeZone: tz })),
      endTime: moment(new Date((this.state.endTime).toDate()).toLocaleString('en-US', { timeZone: tz })),
      time_zone : event.target.value
    })
  }

  handleteam1Name = evt => {
    try {
      this.setState({
        team1Name: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team A Name in dataGenearation");

    }
  }


  handleteam2Name = evt => {
    try {
      this.setState({
        team2Name: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B Name in dataGenearation");
    }
  }


  handleteam1Logo = evt => {
    try {
      this.setState({
        team1Logo: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B LOGO in dataGenearation");
    }
  }


  handleteam2Logo = evt => {
    try {
      this.setState({
        team2Logo: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B LOGO in dataGenearation");
    }
  }


  handleteam1Hex1 = evt => {
    try {
      this.setState({
        team1Hex1: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team A hex1 in dataGenearation");
    }
  }

  handleteam2Hex1 = evt => {
    try {
      this.setState({
        team2Hex1: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B hex1 in dataGenearation");
    }
  }


  handleteam1Hex2 = evt => {
    try {
      this.setState({
        team1Hex2: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team A hex2 in dataGenearation");
    }
  }


  handleteam2Hex2 = evt => {
    try {
      // console.log("EVENT", evt.target.value);

      this.setState({
        team2Hex2: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B hex2 in dataGenearation");
    }
  }


  /********************************************************************************** */

  /**********current date************* */


  getDate = () => {
    var date = new Date().toDateString();
    this.setState({ date });
  };

  /***************************************** */

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }


  /*******************time and date******************************** */

  componentWillMount = () => {
    let date = new Date();
    let dateAndTime = date.toISOString().split("T");
    let time = dateAndTime[1].split(":");
    let final = dateAndTime[0] + "T" + time[0] + ":" + time[1];
    this.setState({
      currentDate: final
    });
  };

  handleChange = date => event => {
    this.setState({ [date]: new Date(event.target.value).toLocaleString() });
    // console.log("OLD DATE IS ", this.state.date);
  };
  sendDate = event => {
    event.preventDefault();
    this.props.ShowNotification("Note Status: ", "Reminder set", "success");
    this.props.reminder(this.state.date, this.props.noteID);
    this.handleClose();
  };


  /******************************************************************************** */




  slideCards = () => {
    try {
      this.setState({ slideCards: !this.state.slideCards });
    } catch (err) {
      console.log("error at slideCards in dashBoard");
    }
  };
  /**
   * @description:it handles the cards style
   */
  handleCardStyle = () => {
    try {
      this.setState({ cardStyles: !this.state.cardStyles });
    } catch (err) {
      console.log("error at handleCardStyle in dashBoard");
    }
  }

  /******************************************************************************************************************************* */

  componentDidMount() {
      console.log("team_id",this.state.getMydata);
    getTeamById(this.state.getMydata)
      .then((response) => {
        console.log("response", response);
        this.setState({
          newData: response,
          team1Name: response[0].eventTeamName,
          team1LogoName: response[0].team1LogoName,
          team1LogoURL: response[0].team_logo,
        });
        

        // console.log("fetchEvent", this.state.newData);
      })
      .catch((error) => {
        console.log(error);
      });
  }


  handleToggle = (e) => {
    e.preventDefault();
    this.setState({ loading: true })
    //try {
    // let stringTimevariable = new Date(this.state.eventTime).toString()
    // let stringDatevariable =new Date(this.state.eventDate).toString()
    // let dateSubstr = stringDatevariable.substr(0,16);
    // let replaced_Val=  stringTimevariable.replace(stringTimevariable.substr(0,16), dateSubstr)

    {
        console.log("team1LogoURL",this.state.team1LogoURL);
      let data = {
        //   userId: localStorage.getItem("user_id"),

        // need userId to send data to firebase
        eventTeamName: this.state.team1Name,
        //teamLogo: this.state.team1LogoURL,
        team1LogoName: this.state.team1LogoName,
        
      };
      
      UpdateTeam(this.state.newData[0].id, data).then((response) => {
        let MyID = sessionStorage.getItem('MyID');
        // axios.put(`https://chrom.tryoncourse.com/refreshEvent/${MyID}/${this.state.newData[0].id}`)
        axios.put(`https://chrom.tryoncourse.com/refreshEvent/${MyID}/${this.state.newData[0].id}`)
          .then((response) => {
            // handle success
            // console.log("Updated ");
            this.setState({
              newData: response
            })
            setTimeout(() => {
               window.location.href = "/teamsScreen"
            }, 100);

          })
          .catch(function (error) {
            // handle error
            console.log(error);
          })
          .finally(function () {
            // always executed
          });

        setTimeout(() => {
           window.location.href = "/teamsScreen"
        }, 100);
      })
        .catch(err => {
          console.log(err);
        });



      this.setState({
        team1Name: '',
        team1Logo: '',
        
        team2Name: '',
        team2Logo: '',

      });
      // }else{
      //   alert("Event cannot be created, the time chosen has already passed, kindly choose the right time");
      // }
    }
    //} catch (err) {
    //   console.log("error at handleToggle in generatingData");
    //}
  };



  RedirectUser = () => {
     this.props.history.push("/teamsScreen");
  };

  /********************************************************************************************************************************* */
  getInfoFromAssests = () => {






    getAssetsInfo()
      .then((response) => {
        // console.log("response", response);
        document.getElementById("EditTeam1Logo").value = "";
        this.setState({


          team1Logo: response[0].teamLogoURL,
          team1Name: response.teamName,
          team1LogoName: response[0].teamLogoName,
          team1LogoURL: response[0].teamLogoURL,
          team1Hex1: response[0].teamHex1,
          team1Hex2: response[0].teamHex2,



        });
        // console.log("fetchEvent", this.state.newData);
      })
      .catch((error) => {
        console.log(error);
      });
    // }


  }

  /**************************************************************************************************************************** */

  render() {



    let { date } = this.state







    let { classes } = this.props;
    let slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";


    return (
      <MuiThemeProvider theme={theme} location={this.props.location}>

        <div className={classes.root}>
          <div className={slidingCards} id={slidingCards}>

            <div style={{ position: 'relative' }}>
              <TopBar
                slideCards={this.slideCards}
                props={this.props}
                notePropsToApp={this.handleCardStyle}
                handleNavigation={this.handleNavigation}
              />
            </div>
          </div>

          {this.state.loading ? <div class="datagenerate">
            <div
              style={{
                textAlign: "center",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "45vh",
                left: "35vw"
              }}
            >
              <Loader type="Circles" color="#422963" height="100%" width="100px" />
            </div>
          </div> :


            <div class="editpage">

              <form onSubmit={this.handleToggle}>
                

                        {/*********************************************************************************************************************** */}

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <h4 style={{ marginTop: 10, textDecorationLine: 'underline', fontWeight: ' bold' }}>Team Information :</h4>



                </div>

                {/************************************************************************************************************************** */}


                {/*****************************************************Team1**************************************************************** */}

                <section class="sectionClass">

                  <div class="container-fluid">
                    <div class="row sectRow">

                      <div class="col-md-4 col-sm-6">

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Team Name:  <span className="red">*</span> </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold', }}>Team Logo: <span className="red">*</span>  </label>
                        </div>



                      </div>


                      <div class="col-md-8 col-sm-6">

                        <div className='labelDivRight' >
                          <Input
                            style={{}}
                            value={this.state.team1Name}
                            onChange={this.handleteam1Name}
                            required
                          />
                        </div>


                        <div style={{ display: 'flex', flexDirection: 'row', margin: '5px' , maxWidth: '350px', position: 'relative' }}>
                          <label
                            for="EditTeam1Logo"
                            className="MyButton"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            onMouseLeave={this.getName}>Upload Image</label>
                          {this.state.image3Checked ? null :
                            <div className=" MinWidth labelDivRight">
                              <span className="red">{this.state.image3Message}</span>
                            </div>}
                          {!this.state.image3Checked ? null :
                            <div>
                             {!this.state.team1LogoURL && this.state.team1LogoName ? <label className="setMyPadding">{this.state.team1LogoName}</label> : <label className="setMyPadding"></label>} 
                              {this.state.team1LogoURL || this.state.team1LogoName ? <FaTrash style={{ position: 'absolute', right: '0' }} className='faTrashDel' onClick={this.removeAsset} /> : null}
                             </div>
                            }
                            
                            {this.state.team1LogoURL ?
                            <div>
                              <img id="EditTeam1Logoim" src={this.state.team1LogoURL }
                              style={{  marginLeft: '50px', width: '30px', height: '30px' }}
                              alt="" //teamLogo
                            />
                            </div>
                          :null}
                        </div>
                      </div>
                    </div>
                  </div>

                </section>



                {/*******************************************TEAM 2************************************************************************* */}

                <section class="sectionClass">

                  <div class="container-fluid">
                    <div class="row sectRow">

                      <div class="col-md-4 col-sm-6">

                        {/* <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold' }}>Team 2 Name: </label>
                    </div> */}




                      </div>


                      <div class="col-md-8 col-sm-6">

                        {/* <div className='labelDivRight' >
                      <Input
                        // disableUnderline={true}
                        style={{}}
                        value={this.state.team2Name}
                        onChange={this.handleteam2Name}
                      />
                    </div> */}


                      </div>


                    </div>
                  </div>

                </section>

                {/******************************************************************************************************************************* */}

                <div>
                  <Button
                    id="button12"
                    className="ButtonStyle"
                    type="submit"
                    type="submit"
                    disabled={this.state.checkDisabled}
                  >
                    Save
            </Button>
                  <input id="EditTeam1Logo" style={{ visibility: 'hidden' }} type="file"></input>
                  <input id="Lighshow" style={{ visibility: 'hidden' }} type="file"></input>
                  {/* <input id="EditeventPhoto" style={{ visibility: 'hidden' }} type="file"></input> */}
                  {/* <input id="EditFiles" style={{ visibility: 'hidden' }} type="file" accept={SheetJSFT} onChange={this.handleFile}></input> */}
                  <input id="EditFiles" style={{ visibility: 'hidden' }} type="file" accept={SheetJSFT}   onChange={(e) => this.checkFile(e)} accept=".ods"></input>
                
                </div>
              </form>
            </div>

          }
        </div>
      </MuiThemeProvider>
    )
  }

}

EditTeamPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};


export default withStyles({ withTheme: true })(EditTeamPage)